(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSection(section) {
    if (section.dataset.depictInit === '1') return;
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    section.dataset.depictInit = '1';

    var prev = section.querySelector('[data-depict-rec-prev]');
    var next = section.querySelector('[data-depict-rec-next]');

    // Sets data-depict-overflow when the row scrolls (drives arrow visibility)
    // and the nav-button disabled state. Skipped while display:none
    // (clientWidth 0); the ResizeObserver re-runs it once the Depict extension
    // reveals the section.
    function update() {
      if (!grid.clientWidth) return;
      var max = grid.scrollWidth - grid.clientWidth;
      var hasOverflow = max > 1;
      var sl = Math.abs(grid.scrollLeft);
      var atStart = sl <= 1;
      var atEnd = sl >= max - 1;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (hasOverflow) {
        section.setAttribute('data-depict-overflow', '');
      } else {
        section.removeAttribute('data-depict-overflow');
      }
    }

    // No behavior key: the grid's CSS scroll-behavior decides smooth vs instant,
    // so prefers-reduced-motion is honored without JS.
    function scrollPage(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.9 });
    }
    if (prev) prev.addEventListener('click', function () { scrollPage(-1); });
    if (next) next.addEventListener('click', function () { scrollPage(1); });

    grid.addEventListener('scroll', update, { passive: true });
    grid.addEventListener('depict:recs-updated', update);
    new ResizeObserver(update).observe(grid);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-complementary-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-dynamic');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(e => {
        const complementaryProductsSwiper = new Swiper('.product-recommendations-dynamic .featured-products-slider', {
          slidesPerView: 4,
          spaceBetween: 6,
          allowTouchMove: false,
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 8
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 3,
              spaceBetween: 8
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 4,
              spaceBetween: 6
            }
          },
          navigation: {
            nextEl: '.product-recommendations-dynamic .swiper-box-arrow-next',
            prevEl: '.product-recommendations-dynamic .swiper-box-arrow-prev',
          }
        });
        new Swiper('.product-card-slider', {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          }
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations-dynamic');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  if(productRecommendationsSection) observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then((e) => {

        const youMayAlsoLikeSwiper = new Swiper('.product-recommendations .featured-products-slider', {
          slidesPerView: 4,
          spaceBetween: 6,
          allowTouchMove: true,
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 4,
              spaceBetween: 6,
            },
            1024: {
              allowTouchMove: false,
            },
          },
          navigation: {
            nextEl: '.product-recommendations .feature-product-slider-header .swiper-next',
            prevEl: '.product-recommendations .feature-product-slider-header .swiper-prev',
          },
        });
        document.querySelectorAll('.product-recommendations .product-card-slider').forEach(function(slider) {
          const slides = slider.querySelectorAll('.swiper-slide');
          const disableOnMobile = slider.closest('[data-disable-slider-on-mobile]') !== null;
          const next = slider.querySelector('.swiper-next');
          const prev = slider.querySelector('.swiper-prev');
          if (slides.length > 1) {
            new Swiper(slider, {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 0,
              allowTouchMove: !disableOnMobile,
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
              breakpoints: {
                748: {
                  enabled: true,
                },
                1024: {
                  allowTouchMove: true,
                },
              },
            });
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  if (productRecommendationsSection) observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
